// NOTE: adapted from us-frontend

import * as React from 'react';
// Providers
import { LabelContext } from '~/vendor/cx-web/feature-i18n';
// Utils
import { DomPurifySanitize } from '~/vendor/cx-web/utils/us-utils';

class FormatCurrency extends React.Component<any, any> {
  static contextType = LabelContext;

  // @ts-ignore
  private currencySymbol: string = this.context.get('CURRENCY_SYMBOL');

  public render(): React.JSX.Element {
    // Extra fallbacks
    let currency;
    if (!this.currencySymbol) {
      currency = '€';
    } else {
      currency = this.currencySymbol;
    }

    let content = '';

    if (currency === '€' || currency === 'kr') {
      content = this.props.value + currency;
    } else {
      content = currency + this.props.value;
    }

    return <span className={this.props.styles} dangerouslySetInnerHTML={{ __html: DomPurifySanitize(content) }} />;
  }
}

export default FormatCurrency;
